export const TEXT_GET_AT = 'Get at ';
export const TEXT_CURRENCY_SYMBOL = '₹';
export const TEXT_SEPARATOR = ' - ';
export const TEXT_DAYS_LEFT_SUFFIX = ' days left';
export const TEXT_DAY_LEFT_SUFFIX = ' day left';

export const ONE_DAY_SECONDS = 24 * 60 * 60;
export const MS_PER_DAY = 1000 * 60 * 60 * 24;
